module.exports = __webpack_public_path__ + "static/media/question_icon.a741efb9.svg";